const Mutations = Object.freeze({
	SET_INVENTORYFORMS: 'inventoryFormModule/formBuilder/SET_INVENTORYFORMS',
	SET_LOADING: 'inventoryFormModule/formBuilder/SET_LOADING',
	ADD_INVENTORY_FORM: 'inventoryFormModule/formBuilder/ADD_INVENTORY_FORM',
	DELETE_INVENTORYFORM:
		'inventoryFormModule/formBuilder/DELETE_INVENTORYFORM',
});

export const Actions = Object.freeze({
	CLEAR: 'inventoryFormModule/formBuilder/CLEAR',
	LOAD: 'inventoryFormModule/formBuilder/LOAD',
	DELETE: 'inventoryFormModule/formBuilder/DELETE',
	CLONE: 'inventoryFormModule/formBuilder/CLONE',
});

export const Getters = Object.freeze({
	FORMS: 'inventoryFormModule/formBuilder/FORMS',
	LOADING: 'inventoryFormModule/formBuilder/LOADING',
});
import dataService from '../../../../../../services/data/inventoryFormService';
import { GeneralActions, InventoryFormActions } from '../../../../../actions';
import assignUsers from './assignUsers';
import formFields from './formFields';
import interactions from './interactions';
import formDetails from './formDetails';
import filters from './filters';
import mobileAppConfig from './mobileAppConfig';

export default {
	state: {
		inventoryForms: [],
		loading: false,
	},
	modules: {
		formDetails,
		formFields,
		interactions,
		assignUsers,
		filters,
		mobileAppConfig,
	},
	mutations: {
		[Mutations.SET_INVENTORYFORMS](state, value) {
			state.inventoryForms = value;
		},
		[Mutations.ADD_INVENTORY_FORM](state, item) {
			state.inventoryForms.push(item);
		},
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},

		[Mutations.DELETE_INVENTORYFORM](state, item) {
			let form = state.inventoryForms.find((x) => x.Id == item.Id);
			let index = state.inventoryForms.indexOf(form);
			if (index < 0) return;
			state.inventoryForms.splice(index, 1);
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_INVENTORYFORMS, []);
				commit(Mutations.SET_LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.getAllForms()
					.then((resp) => {
						commit(Mutations.SET_INVENTORYFORMS, resp.data);
						commit(Mutations.SET_LOADING, false);
						resolve();
					})
					.catch((error) => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.DELETE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteForm(item.Id)
					.then(() => {
						commit(Mutations.DELETE_INVENTORYFORM, item);
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.CLONE]({ dispatch, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.cloneForm(item)
					.then((resp) => {
						commit(Mutations.ADD_INVENTORY_FORM, resp.data);
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.FORMS]: (state) => {
			return JSON.parse(
				JSON.stringify(
					state.inventoryForms.sort((a, b) =>
						a.Name > b.Name ? 1 : -1
					)
				)
			);
		},
		[Getters.LOADING]: (state) => {
			return JSON.parse(JSON.stringify(state.loading));
		},
	},
};
